import { injectable, interfaces } from 'inversify';
import { action, makeObservable, observable } from 'mobx';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../../../__legacy__/models/paginationInfo.model';
import { ExportDataFilter } from '../../../../__legacy__/modules/projects/projects.model';
import { IProjectExport } from './models/ProjectExport';
import { GetProjectExportsResponse } from './services/ExportServiceDTOs';

export interface IExportDataStore {
  readonly paging: IPagingInfoWithOrder;
  readonly isCurrentExportGenerated: boolean;
  readonly isCurrentlyGenerating: boolean;
  readonly lastAnnotationChange: Date;
  readonly latestExportId: string;
  readonly projectExports: IProjectExport[];
  readonly projectId: string;
  readonly selectedDataFilter: ExportDataFilter;
  readonly showExportModal: boolean;
  readonly showDownloadModal: boolean;
  readonly showLoader: boolean;
  readonly downloadProjectExportId: string;
  readonly downloadDataFilter: ExportDataFilter;

  load(projectId: string, response: GetProjectExportsResponse): void;
  setShowExportModal(showModal: boolean): void;
  setShowDownloadModal(showModal: boolean, downloadProjectExportId: string, downloadDataFilter: ExportDataFilter): void;
  setSelectedDataFilter(dataFilter: ExportDataFilter): void;
  setIsCurrentlyGenerating(isCurrentlyGenerating: boolean): void;
  setShowLoader(showLoader: boolean): void;
}

export namespace IExportDataStore {
  export const $: interfaces.ServiceIdentifier<IExportDataStore> = Symbol('EXPORT_DATA_STORE');
}

const ProjectExportsDefaultPaging = {
  ...PaginationInfoDefault,
  orderBy: 'createdDate',
  orderType: 'desc',
  search: '',
};

@injectable()
export class ExportDataStoreImpl implements IExportDataStore {
  lastAnnotationChange: Date = new Date();

  isCurrentExportGenerated: boolean = false;

  isCurrentlyGenerating: boolean = false;

  projectExports: IProjectExport[] = [];

  showExportModal: boolean = false;

  showDownloadModal: boolean = false;

  selectedDataFilter: ExportDataFilter = ExportDataFilter.ALL;

  latestExportId: string = '';

  projectId: string = '';

  paging: IPagingInfoWithOrder = ProjectExportsDefaultPaging;

  showLoader: boolean = false;

  downloadProjectExportId: string = '';

  downloadDataFilter: ExportDataFilter = ExportDataFilter.ALL;

  constructor() {
    makeObservable(this, {
      lastAnnotationChange: observable,
      isCurrentExportGenerated: observable,
      isCurrentlyGenerating: observable,
      projectExports: observable,
      showExportModal: observable,
      showDownloadModal: observable,
      selectedDataFilter: observable,
      latestExportId: observable,
      projectId: observable,
      paging: observable,
      showLoader: observable,
      downloadProjectExportId: observable,
      downloadDataFilter: observable,
      load: action,
      setSelectedDataFilter: action,
      setShowExportModal: action,
      setShowDownloadModal: action,
      setSelectedDataFilteR: action,
      setIsCurrentlyGenerating: action,
      setShowLoader: action,
    });
  }

  load(projectId: string, response: GetProjectExportsResponse): void {
    this.projectId = projectId;
    this.isCurrentExportGenerated = response.isCurrentExportGenerated;
    this.isCurrentlyGenerating = response.isCurrentlyGenerating;
    this.lastAnnotationChange = response.lastAnnotationChange;
    this.latestExportId = response.latestExportId;
    this.projectExports = response.projectExports.data;

    this.paging = {
      ...this.paging,
      pageNumber: response.projectExports.pageNumber,
      pagesCount: response.projectExports.pagesCount,
      totalCount: response.projectExports.totalCount,
    };

    this.showLoader = false;
  }

  setSelectedDataFilter(dataFilter: ExportDataFilter): void {
    this.selectedDataFilter = dataFilter;
  }

  setShowExportModal(showModal: boolean): void {
    this.showExportModal = showModal;
  }

  setShowDownloadModal(showModal: boolean, downloadProjectExportId: string, downloadDataFilter: ExportDataFilter): void {
    this.showDownloadModal = showModal;
    this.downloadProjectExportId = downloadProjectExportId;
    this.downloadDataFilter = downloadDataFilter;
  }

  setSelectedDataFilteR(dataFilter: ExportDataFilter): void {
    this.selectedDataFilter = dataFilter;
  }

  setIsCurrentlyGenerating(isCurrentlyGenerating: boolean): void {
    this.isCurrentlyGenerating = isCurrentlyGenerating;
  }

  setShowLoader(showLoader: boolean): void {
    this.showLoader = showLoader;
  }
}
